// Global state to track which picker is currently open
const currentOpenPickerId = ref<string | null>(null);
const pickerRefs = new Map<string, { hide: () => void }>();

export const usePickerState = () => {
  const pickerId = `picker-${Math.random().toString(36).substr(2, 9)}`;

  const isOpen = computed(() => currentOpenPickerId.value === pickerId);

  // Check if any picker is open (for backdrop)
  const anyPickerOpen = computed(() => currentOpenPickerId.value !== null);

  const open = (hideCallback: () => void) => {
    // Close previously open picker
    if (currentOpenPickerId.value && currentOpenPickerId.value !== pickerId) {
      const prevPicker = pickerRefs.get(currentOpenPickerId.value);
      if (prevPicker) {
        prevPicker.hide();
      }
    }
    
    // Register this picker's hide callback
    pickerRefs.set(pickerId, { hide: hideCallback });
    currentOpenPickerId.value = pickerId;
  };

  const close = () => {
    if (currentOpenPickerId.value === pickerId) {
      currentOpenPickerId.value = null;
    }
  };

  const closeAll = () => {
    if (currentOpenPickerId.value) {
      const currentPicker = pickerRefs.get(currentOpenPickerId.value);
      if (currentPicker) {
        currentPicker.hide();
      }
      currentOpenPickerId.value = null;
    }
  };

  const toggle = (hideCallback: () => void) => {
    if (isOpen.value) {
      close();
    } else {
      open(hideCallback);
    }
  };

  // Cleanup on unmount
  onUnmounted(() => {
    pickerRefs.delete(pickerId);
    if (currentOpenPickerId.value === pickerId) {
      currentOpenPickerId.value = null;
    }
  });

  return {
    pickerId,
    isOpen,
    anyPickerOpen,
    open,
    close,
    closeAll,
    toggle,
  };
};

// Export reactive state for backdrop component
export const usePickerBackdrop = () => {
  const isVisible = computed(() => currentOpenPickerId.value !== null);
  
  const close = () => {
    if (currentOpenPickerId.value) {
      const currentPicker = pickerRefs.get(currentOpenPickerId.value);
      if (currentPicker) {
        currentPicker.hide();
      }
      currentOpenPickerId.value = null;
    }
  };

  return {
    isVisible,
    close,
  };
};
